import { useLocalObservable } from 'mobx-react-lite';
import { useEffect } from 'react';

import { RemoteImageObject } from '@gem/modules/remote-storage';
import { AvatarPopup } from '@gem/popups';

import Tasks from 'APP/Tasks';
import Entities from 'STORE';

interface IAvatarWithFullScreenPresenter {
  url?: string;
  isClickable: boolean;
  openFullScreen(): void;
  preloadFullScreenImage(): void;
  setUrl(url: string | undefined): void;
}

export function useAvatarWithFullScreenPresenter(url?: string): IAvatarWithFullScreenPresenter {
  const presenter = useLocalObservable<IAvatarWithFullScreenPresenter>(() => ({
    url,

    get isClickable(): boolean {
      if (!presenter.url) {
        return false;
      }

      return Entities.CachedImages.isCachedImage(presenter.url);
    },

    openFullScreen(): void {
      const image = new RemoteImageObject();
      image.src = presenter.url || '';
      image.onload = (): void => {
        Tasks.app.openPopup(AvatarPopup, { params: { url: image.processedSrc } });
      };
    },

    preloadFullScreenImage(): void {
      if (presenter.url) {
        Tasks.app.preloadImage(presenter.url);
      }
    },

    setUrl(url: string | undefined): void {
      presenter.url = url;
    },
  }));

  useEffect(() => {
    presenter.setUrl(url);
    presenter.preloadFullScreenImage();
  }, [url]);

  return presenter;
}
